<template>
  <div class="p-1">
     <div-table :config="configList"  :sous_idWharhouse="sous_idWharhouse" :couriers="couriers" :sous_warehouses="sous_warehouses" :idWharhouse="idWharhouse" :currentUser="currentUser" :isFilterPaidOrCourier="isFilterPaidOrCourier" :CourierInfo="CourierInfo" :products="products" :limit="limit" @Changelimit="Changelimit" @downloadShippings="downloadShippings" @emtyTabId="emtyTabId" @selectAllCheckbox="selectAllCheckbox" @getRowDetail="getRowDetail" :tabId="tabId" :CheckQteDefecteuseexist="CheckQteDefecteuseexist" :CheckQteReturnedexist="CheckQteReturnedexist" :data="shippings" @CheckQteDefecteuse="CheckQteDefecteuse" @CheckQteReturned="CheckQteReturned" @reset="reset" :element="element" :zones="zones" :typesShipp="typesShipp" :statusShipp="statusShipp"  :statusShippChange="statusShippChange" @refresh="refresh" @filtrer="filtrer" @search="search" :loading="loading" :paginate="paginate" @showProducts="showProducts" @generateListPdf="generateListPdf" @paginatation="paginatation"></div-table>
  </div>
</template>

<script>
import jsPDF from 'jspdf'
import 'jspdf-autotable'
import config from './config'
export default {
  props: {
     currentUser: { type: Object},
     idWharhouse: { type: Object},
     sous_idWharhouse: { type: String},
     sous_warehouses: { type: Array},
   },
  data() {
    return {
       configList: config.list,
       loading:false,
       CheckQteDefecteuseexist:false,
       CheckQteReturnedexist:false,
       content: {},
       shippings:[],
       tabId:[],
       tabIdList:[],
       couriers: [],
       shippingsStockManager:[],
       shippingsLivreur:[],
       element: {},
       filters:{},
       limit: 50,
       sellers: [],
       paginate: {
        total: 0,
        currentpage: 1,
        lastpage: 1,
        per_page: 0,
       },
       CourierInfo:{
         courier:'',
         total:0,
         count:0,
         status:"",
         countpending:0
       },
       isFilterPaidOrCourier:false,
      statusShippSearch: ["queued", "prepared", "shipped",'reprogrammed','received','paid','processed','cancelled','refunded'],
      statusShipp: ["queued", "prepared", "shipped",'reprogrammed','received','paid','cancelled','refunded'],
      statusShippChange:["prepared", "shipped",'reprogrammed','received','cancelled','paid'],
      typesShipp:["pendingchange", "change"],
      zones:[],
       products:[],
    };
  },
  computed: {
    warhouseSelected(){
          return this.$store.getters["wharhouse/warhouseSelected"]({user:_.pick(this.currentUser,['warehouses'])});
    },
  }, 
  watch: { 
      'warhouseSelected': async function(oldVal, newVal) {
          //  await this.getwharhouseId();
          //  await this.reset();
          //  await this.methodeChangeData();   
      },
      'idWharhouse': async function(oldVal, newVal) {
          this.idWharhouse=oldVal;  
          await this.reset({isChangeW:true});
          await this.methodeChangeData();   
      },
      'sous_idWharhouse': async function(oldVal, newVal) {
          this.sous_idWharhouse=oldVal;  
          if(this.currentUser.type != "Admin") this.limit=10;this.filters.limit=10
          await this.reset({isChangeW:true});
          await this.methodeChangeData();   
      }
},
  async mounted() {
    if (this.currentUser.type != "Admin") this.limit=10;
    if(!this.$f.QueryStringToobject()) {
      let filtersobjectToQueryString={limit:this.limit,warehouse:this.idWharhouse._id};
      if(this.sous_idWharhouse && this.sous_warehouses.length>0 && this.sous_idWharhouse!='all') filtersobjectToQueryString['orderObjet.details.warehouseParent']=this.sous_idWharhouse;
      this.$f.objectToQueryString(filtersobjectToQueryString)
    }
     this.filters=this.$f.QueryStringToobject();
    if(this.filters.name) await this.search(this.filters.name);
    else await this.getShipping(this.filters);
    //console.log('shippings__________________',this.shippings)
    //this.filters[0].values = this.categories;
     await this.methodeChangeData();
     //this.setDataSelect('category',this.categories,null); 
     
       if (this.currentUser.type == "Courier") {
         const index = this.statusShipp.indexOf("queued");
         if (index > -1) this.statusShipp.splice(index, 1);
       }
       if (this.currentUser.type == "Seller" || this.currentUser.type == "Accountant") {
           let posseller = this.configList.columns.map(function (e) {return e.name;}).indexOf('Seller');
            if(posseller!=-1)  this.configList.columns.splice(posseller, 1);  
            if (this.currentUser.type == "Seller"){
               await this.getProducts();
              let posCourier = this.configList.columns.map(function (e) {return e.name;}).indexOf('Courier');
              let poszone = this.configList.columns.map(function (e) {return e.name;}).indexOf('Zone');
              if(posCourier!=-1)  this.configList.columns.splice(posCourier, 1);   
              if(poszone!=-1)  this.configList.columns.splice(poszone, 1);   
           }             
         }
        // if (this.currentUser.type == "StockManager") {
        //    this.statusShipp.splice(2,4);
        // }
     this.setDataSelect('status',this.statusShippSearch,null);  
     this.setDataSelect("type", ['normal','echange'], null);
     
     if (this.currentUser.type == "Accountant") this.statusShippChange =['received'];
      if (this.currentUser.type != "Admin" && this.currentUser.type != "Administrateur") {
         const indexx = this.statusShippChange.indexOf("paid");
         const indexxx = this.statusShippChange.indexOf("processed");
          if (indexx > -1) this.statusShippChange.splice(indexx, 1);
          if (indexxx > -1) this.statusShippChange.splice(indexxx, 1);
           if (this.currentUser.type === "StockManager") {
               const k = this.statusShippChange.indexOf("received");
               if (indexx > -1) this.statusShippChange.splice(k, 1);
                this.statusShipp.splice(3,4);
           }
      }
      //console.log('shipping_______________________',this.shippings)
  },

  filters: {},
  methods: {
    async getwharhouseId(){
       await this.$store.dispatch('wharhouse/getwharhouseId',{country: this.warhouseSelected,}).then((res) => {this.idWharhouse=res;})
    }, 
    async methodeChangeData(){
      await this.getSellers();
      await this.getCouriers();
      this.setDataSelect('seller',this.sellers,null); 
      this.setDataSelect("courier", this.couriers, null);
      await this.getZones();
     this.setDataSelect('zone',this.zones,null); 
    },
    async Changelimit(val){
      if(this.$f.QueryStringToobject()) this.filters=this.$f.QueryStringToobject();
       this.filters['limit']=val;
       this.filters['page']=1;
       this.paginate.currentpage=1;
       this.$f.objectToQueryString(this.filters)
       if(this.filters.name) await this.search(this.filters.name);
       else this.getShipping(this.filters);
    },
    sumProduct(data){
      let product="";
      for (let i in data) {
        product+=data[i].product.name
        if(data.length-1 != i) product+=" ,"; 
      }
      return product;
    },
    sumQuantity(data) {
      if (!Array.isArray(data)) return "";

      return data
        .filter(item => item && item.quantity != null)
        .map(item => item.quantity)
        .join(", ");
    },
     async getProducts(seller=null){
      const filter={'details.warehouse':this.idWharhouse._id,limit:10};
      if(seller) filter.seller=seller;
      const res = await this.$server.search("products",filter);
      //console.log('res pproduct----------',res.content)
      if (res.content.results) {
        this.products = res.content.results;
      } else this.products = [];
    },
    sumQunitPrices(data){
      let unitPrices="";
      for (let i in data) {
        unitPrices+=data[i].unitPrice.toString()
        if(data.length-1 != i) unitPrices+=" ,"; 
      }
      return unitPrices;
    },
    async downloadShippings(){
      console.log('ooook');
        var arr = typeof this.shippings !== 'object' ? JSON.parse(this.shippings) : this.shippings;

        for (let i in arr) {
              arr[i].Seller=arr[i].seller.fullName||arr[i].seller.email;
              arr[i].ShippingAddress=arr[i].address?arr[i].address.replace(/[^a-zA-Z 0-9]+/g,''):'';
              arr[i].ShippingDate=this.$moment(arr[i].date).format("YYYY-MM-DD HH:mm");
              arr[i].Customer=arr[i].order.customer.fullName.replace(/[^a-zA-Z 0-9]+/g,'');
              arr[i].Phone=arr[i].order.customer.phone;
              arr[i].Phone2=arr[i].order.customer.shippingPhone?arr[i].order.customer.shippingPhone:'';
              arr[i].Products =this.sumProduct(arr[i].order.details);
              arr[i].Quantitys =this.sumQuantity(arr[i].order.details);
              arr[i].UnitPrices =this.sumQunitPrices(arr[i].order.details);
              arr[i].TotalPrice =arr[i].order.totalPrice;
              arr[i].TrakingNumber=arr[i].trackingNumber;
              arr[i].Courier=arr[i].courier?arr[i].courier.fullName||arr[i].courier.email:"";
              arr[i].Status=arr[i].status;
              arr[i].Accounting=arr[i].accounting?arr[i].accounting.fullName||arr[i].accounting.email:"";
              arr[i].Returned=arr[i].comment?arr[i].comment:"";
        }
        for (let j in arr) {
              delete arr[j].order_id;
              delete arr[j].courier;
              delete arr[j].accounting;
              delete arr[j].createdAt;
              delete arr[j].address;
              delete arr[j].date;
              delete arr[j].isDeleted;
              delete arr[j].order;
              delete arr[j].price;
              delete arr[j].seller;
              delete arr[j].status;
              delete arr[j].trackingNumber;
              delete arr[j]._id;
              delete arr[j].type;
              delete arr[j].zone;
              delete arr[j].comment;
               delete arr[j].__v;
               delete arr[j].updatedAt;
          }
          console.log('orders rr______',arr)
        let str =
          `${Object.keys(arr[0])
            .map((value) => `"${value}"`)
            .join(',')}` + '\r\n';
        let csvContent = arr.reduce((st, next) => {
          st +=
            `${Object.values(next)
              .map((value) => `"${value}"`)
              .join(',')}` + '\r\n';
          return st;
        }, str);
        let element = document.createElement('a');
        element.href = 'data:text/csv;charset=utf-8,%EF%BB%BF' + encodeURI(csvContent);
        element.target = '_blank';
        element.download = 'shippings.csv';
        element.click();
        //await this.getShipping(this.filters);
    },  
     selectAllCheckbox($event) {
        let columns = document.querySelectorAll('.rowCheckbox');
        this.tabId = [];
        if ($event.target.checked == true) {
          
            columns.forEach(column => {
                column.checked = true;           
                this.tabId.push({id:column.id,source:column.getAttribute('seller'),order:column.getAttribute('order'),date:column.getAttribute('date'),refund:column.getAttribute('refund'),trackingNumber:column.getAttribute('trackingNumber'),status:column.getAttribute('status'),orderobjet:column.getAttribute('orderobjet')});
            });
        } else {
            columns.forEach(column => {column.checked = false});
            this.tabId = [];
        }
    },
    getRowDetail(item, id) {
 
        // let rows = this.selectedRows;
        let itemInRow = this.tabId.filter(item => item.id === id);
        let isItemInRow = itemInRow.length > 0;
            
        if (isItemInRow) { 
            let pos = this.tabId.map(function (e) {return e.id;}).indexOf(id);
            this.tabId.splice(pos, 1);
        } else {
            this.tabId.push({id:id,source:item.seller.source?item.seller.source:'nosource',order:item.order._id,date:item.date,refund:item.refund,status:item.status,trackingNumber:item.trackingNumber,orderobjet:JSON.stringify({id:item.order.id,totalPrice:item.order.totalPrice,teleConsultantConfirm:item.order.teleConsultantConfirm,seller:{_id:item.order.seller._id||item.order.seller},source:item.order.source,customer:item.order.customer,details:item.order.details.map( el => ({product: {_id:el.product._id,quantity:el.product.quantity}, quantity: el.quantity}) ) })});
        }
            
          if(this.tabId.length === 0){
              let columns = document.querySelectorAll('.checkallbbox');
              columns.forEach(column => {column.checked = false});
        }
    },
    emtyTabId(){
      console.log('goooood check')
      let columns = document.querySelectorAll('.rowCheckbox');
      columns.forEach(column => {column.checked = false});
      let clomnselectA = document.querySelector('.checkallbbox');
      clomnselectA.checked = false

      this.tabId = [];
    },
    async getCouriers() {
      if (this.currentUser.type != "Seller") {
          const filter = {
            type: "Courier",
            warehouses:this.idWharhouse._id,
            limit:10
          };
          const res = await this.$server.search("users", filter);
          if (res && res.content.results) this.couriers = res.content.results;
          else this.couriers = [];
      }
    },
    async getSellers() {
       if (this.currentUser.type != "Seller") {
          const filter = {
              type: "Seller",
              warehouses:this.idWharhouse._id,
              limit:10
          };
          const res = await this.$server.search("users", filter);
          if (res.content.results) this.sellers = res.content.results;
          else this.sellers = [];
       }
    },
    async getZones() {
        const res = await this.$server.search("zones",{ limit: 10,warehouse:this.idWharhouse._id});
        if (res.content.results) this.zones = res.content.results;
        else this.zones = [];
    },
    setDataSelect(model,data,splice){
      for (var i = 0; i < this.configList.filters.elements.champs.length; i++) {
            if ( this.configList.filters.elements.champs[i].type === "select" && this.configList.filters.elements.champs[i].key === model) {
                if(!splice){
                  this.configList.filters.elements.champs[i].values=data;
                }else{
                  this.configList.filters.elements.champs.splice(i, 1);
                }               
            }
        }
    },
    setUserId(filters) {
      return (filters.seller = this.currentUser._id);
    },
    showProducts(index) {
      if (this.element !== this.shippings[index]) {
        this.element = this.shippings[index];
      } else this.element = null;
    },
    async CheckQteDefecteuse(item){
       this.CheckQteDefecteuseexist=false;
       if(item.type=='change' ){
             for (let i in item.order.details) {
                 const filters = {
                   product: item.order.details[i].product._id,
                   order: item.order._id,
                   shipping: item._id,
                 };
               const res = await this.$server.search("stockHistories", filters);
              
               if(typeof res.content.results !== 'undefined') {
                   item.order.details[i].product.qteChange=res.content.results[0].quantity;
                   this.CheckQteDefecteuseexist=true;
               }
             }
       }    
       // console.log('CheckQteDefecteuseexist',this.CheckQteDefecteuseexist)
     }, 
    async CheckQteReturned(item){
      //console.log('item sip_____________',item)
       this.CheckQteReturnedexist=false;
       if(item.status=='cancelled' ){
             for (let i in item.order.details) {
                 const filters = {
                   product: item.order.details[i].product._id,
                   order: item.order._id,
                   shipping: item._id,
                 };
               const res = await this.$server.search("stockHistories", filters);
              
               if(typeof res.content.results !== 'undefined') {
                   item.order.details[i].product.qteChange=res.content.results[0].quantity;
                   this.CheckQteReturnedexist=true;
               }
             }
       }    
        //console.log('CheckQteDefecteuseexist',this.CheckQteReturnedexist)
     },
    async getShipping(filters) {
      //filters=this.setUserId();
      this.loading = true;

      if(filters.isChangeW){ delete filters.isChangeW;this.shippings = [];this.paginate={total: 0,currentpage: 1,lastpage: 1,per_page: 0,}} 

      if (this.currentUser.type != "Courier") delete filters.search
      filters.warehouse=this.idWharhouse._id;
      if(this.sous_idWharhouse && this.sous_warehouses.length>0 && this.sous_idWharhouse!='all') filters['orderObjet.details.warehouseParent']=this.sous_idWharhouse;
      const res = await this.$server.search("shippings", filters);
      this.CourierInfo.total=this.CourierInfo.count=this.CourierInfo.countpending=0;
      this.loading = false;
      if (res && res.content.results) {
        this.shippings = res.content.results;
        this.paginate.total = res.content.total;
        this.paginate.lastpage = res.content.last_page;
        this.paginate.per_page = res.content.per_page;
        this.paginate.currentpage = res.content.current_page;
        console.log("this.shippings--------------------",this.shippings)
          for (const element of  this.shippings) {
             if(this.isFilterPaidOrCourier){
                   this.CourierInfo.count =this.shippings.length;
                   if(element.refund) element.order.totalPrice=element.order.totalPrice*(-1)
                   if(element.isProcessed && element.status=='paid') this.CourierInfo.countpending ++;
                   this.CourierInfo.total +=element.order.totalPrice;
               }
               // element.date=this.$moment.utc(element.date).format('YYYY-MM-DD');
                element.order_id=element.orderObjet.id;  
                element.seller=element.orderObjet.seller;  
                //if(!element.courier)  element.courier={email:"",fullName:""}
                // for(let j in  element.order.details){
                //   element.order.details[j].product.qteChange=element.order.details[j].quantity;
                // }

                if (
                  element &&
                  element.order &&
                  element.order.details &&
                  Array.isArray(element.order.details)
                ) {
                  for (let j = 0; j < element.order.details.length; j++) {
                    const detail = element.order.details[j];

                    if (detail && detail.product) {
                      this.$set(detail.product, 'qteChange', detail.quantity);
                    }
                  }
                }

          }
      } else {this.shippings = [];
               this.paginate={total: 0,currentpage: 1,lastpage: 1,per_page: 0,}
      }
     
    },
    async getUserByid(id) {
       const filters = {
         _id:id
       }
       const res= await this.$server.find("users",filters);
        if (res.content) {
          return res.content[0].email;
         };
    },
    async getShippingStockManager() {
       const filters = {
          status: "queued",
          dateShipp:this.$moment(Date.now()).format('YYYY-MM-DD'),
          warehouse:this.idWharhouse._id
      };
      const res = await this.$server.search("shippings", filters);
      console.log('shipping information',res.content)
      if (res.content.results) {
        this.shippingsStockManager = res.content.results;
      } else this.shippingsStockManager = [];
    },
     async getShippingLivreur() {
       const filters = {
          status: "prepared",
          dateShipp:this.$moment(Date.now()).format('YYYY-MM-DD'),
          warehouse:this.idWharhouse._id
      };
      const res = await this.$server.search("shippings", filters);
      if (res.content.results) {
        this.shippingsLivreur = res.content.results;
      } else this.shippingsLivreur = [];
    },

    async refresh() {
      this.emtyTabId();
      if(this.$f.QueryStringToobject()) this.filters=this.$f.QueryStringToobject();
      this.$f.objectToQueryString(this.filters);
      if(this.filters.name) await this.search(this.filters.name);
      else this.getShipping(this.filters);
      this.isFilterPaidOrCourier=false;
      // if(this.filters['page'] && this.filters['page']>1 && this.shippings.length==0){
      //     this.filters['page']= --this.filters['page'];
      //     this.$f.objectToQueryString(this.filters)
      //     await this.getShipping(this.filters);
      //  }
    },

    /*********************************************************************************/
    async reset(data) {
      let lmitt=this.limit;
      if(this.$f.QueryStringToobject()) this.filters=this.$f.QueryStringToobject();
      if(this.filters['limit']) lmitt=this.filters['limit'];
       this.filters['page']=1;
       let filterO={limit:lmitt,warehouse:this.idWharhouse._id};
       if(this.sous_idWharhouse && this.sous_warehouses.length>0 && this.sous_idWharhouse!='all') filterO['orderObjet.details.warehouseParent']=this.sous_idWharhouse;
      this.$f.objectToQueryString(filterO)
      this.isFilterPaidOrCourier=false;
      
      let filtersShipp={limit:lmitt};
      if(data.isChangeW) filtersShipp.isChangeW=true;
      await this.getShipping(filtersShipp);
    },
    async search(data) {
       this.paginate= {total: 0,currentpage: 1,lastpage: 1,per_page: 0,};
        let limitt=this.limit
       if(this.filters['limit']) limitt=this.filters['limit'];

       const search = {name:data.trim(),limit:parseInt(limitt)}
      
       search.warehouse=this.idWharhouse._id;
       if(this.sous_idWharhouse && this.sous_warehouses.length>0 && this.sous_idWharhouse!='all') search['orderObjet.details.warehouseParent']=this.sous_idWharhouse;
       this.$f.objectToQueryString(search)
       console.log('search shipp_________',search)
       this.loading = true;
      const res = await this.$server.find("shippings", search);
      this.loading = false;
      if (res && res.content.results) {
        this.shippings = res.content.results;
        this.shippings.total = res.content.total;
        this.shippings.lastpage = res.content.last_page;
        this.shippings.per_page = res.content.per_page;
        this.shippings.currentpage = res.content.current_page;
         for (const element of  this.shippings) {
               // element.date=this.$moment.utc(element.date).format('YYYY-MM-DD');
                element.order_id=element.orderObjet.id;  
                element.seller=element.orderObjet.seller;  
                // if(!element.courier)  element.courier={email:"",fullName:""}
                //  for(let j in  element.order.details){
                //   element.order.details[j].product.qteChange=1;
                // }
                if (
                  element &&
                  element.order &&
                  element.order.details &&
                  Array.isArray(element.order.details)
                ) {
                  for (let j = 0; j < element.order.details.length; j++) {
                    const detail = element.order.details[j];

                    if (detail && detail.product) {
                      this.$set(detail.product, 'qteChange', detail.quantity);
                    }
                  }
                }
          }
      } else{this.shippings = []; this.paginate={total: 0,currentpage: 1,lastpage: 1,per_page: 0,}} 
    },
    async filtrer(data) {
       if(this.$f.QueryStringToobject()) this.filters=this.$f.QueryStringToobject();
       delete  this.filters.page;
       delete  this.filters.name;

       if(!this.filters['limit']) this.filters['limit']=this.limit;
       if(data.status)  this.filters.status=data.status;else delete this.filters.status;
       if(data.Range_date){this.filters.Range_date=data.Range_date.map( el => this.$moment(el).format('YYYY-MM-DD'));}else delete this.filters.Range_date;
       if(data.seller)  {this.filters.seller=data.seller._id;await this.getProducts(data.seller._id);}else delete this.filters.seller;
       if(data.product)  this.filters.product=data.product._id;else delete this.filters.product;
       if(data.type)  this.filters.type=data.type;else delete this.filters.type;
       if(this.sous_idWharhouse && this.sous_warehouses.length>0 && this.sous_idWharhouse!='all') this.filters['orderObjet.details.warehouseParent']=this.sous_idWharhouse;else delete this.filters['orderObjet.details.warehouseParent'];
       this.paginate.currentpage=1;

       if (this.currentUser.type == "Courier")  this.filters.search=true;
      if(data.zone)   this.filters.zone=data.zone._id;else delete this.filters.zone;
      if (data.courier) {
         if (this.currentUser.type == "Admin" || this.currentUser.type == "Administrateur" || this.currentUser.type == "Accountant" ){this.isFilterPaidOrCourier=true;this.CourierInfo.courier=data.courier.fullName||data.courier.email}
           this.filters.courier = data.courier._id;
      }else {delete this.filters.courier;this.CourierInfo.courier=null;}

      if(data.status && ['paid', 'received','processed'].indexOf(data.status) !== -1) this.isFilterPaidOrCourier=true;
      if((!data.status || (data.status && data.status!="paid" && data.status!="received" && data.status!="processed")) && !data.courier) this.isFilterPaidOrCourier=false;
      this.$f.objectToQueryString(this.filters)
      await this.getShipping( this.filters);
    },
    /****************************************************************************/
    async getUser() {
      const res = await this.$server.me("users");
      if (res.content) this.currentUser = res.content;
      else this.currentUser = [];
      console.log(this.currentUser);
    },
    /***************************************************************************************/
    async paginatation(direction){
      var page=0;
      if(direction == "next"){
         page=++this.paginate.currentpage;
      }else{
         page=--this.paginate.currentpage;
      }

      if(this.$f.QueryStringToobject()) this.filters=this.$f.QueryStringToobject();
      this.filters['page']=page;
      this.$f.objectToQueryString(this.filters)

      this.getShipping( this.filters);
    },
    sumQteProduct(data){
      let sum=0;
      for (let i in data) {
        sum=sum+data[i].quantity;
      }
      return sum;
    },
    generateListPdf() {
          this.tabIdList=[];
          // if (this.currentUser.type == "StockManager") items=this.shippingsStockManager;
          // if (this.currentUser.type == "Courier") items=this.shippingsLivreur;
           for(let i in this.shippings){
              this.tabIdList.push(this.shippings[i]._id)
           }
            if(this.tabIdList.length==0){
                alert(`No Shipping found !`, "warning");
                return false;
            }

          const chunkSize = 10;
          const groups = this.tabIdList.map((e, i) => { 
              return i % chunkSize === 0 ? this.tabIdList.slice(i, i + chunkSize) : null; 
          }).filter(e => { return e; });

             var tableheader = '<table class="min-w-full" style="page-break-after: avoid; page-break-before: avoid;"><tbody class="bg-white">';
        
              tableheader += '<tr style="height: 5mm;" class="w-full">';
              tableheader += '<td style="border:none!important"  class="px-1 py-1 align-top"><label class="text-black block text-xs whitespace-normal" style="font-size: 0.43rem;line-height: 0.80rem;"><span class="font-bold">Total orders:</span> <span style="font-size: 0.43rem;" class="text-black text-xs tracking-wide"> '+this.shippings.length+'</span><span style="margin-left:5px"><span class="font-bold">Courier:</span>';
              if(this.shippings[0].courier) tableheader += '<span style="font-size: 0.43rem;" class="text-black text-xs tracking-wide"> ' +this.shippings[0].courier.fullName+' </span>';
              printContents += '</span><span style="margin-left:5px"><span class="font-bold">Zone:</span>';
              if(this.shippings[0].zone) tableheader += '<span style="font-size: 0.43rem;" class="text-black text-xs tracking-wide"> '+this.shippings[0].zone.name+' </span>';
              tableheader += '</span></label></td>';
              tableheader += '<td style="border:none!important" class="px-3 py-1 align-top"><label class="text-black block text-xs whitespace-normal" style="font-size: 0.43rem;line-height: 0.80rem;"></td>';
              tableheader += '</tr></tbody><tbody>';
              var  tablefooter ='</tbody></table>';
              var printContents="";
            if(this.tabIdList.length==1){
                printContents +=tableheader;
                let modalPr_id = "ModalprintList_" + this.tabIdList[0];
                printContents += '<tr style="height: 38mm;" class="bg-white">';
                printContents += '<td style="width:50%;" class="px-3 py-1 align-top border border-black">'+document.getElementById(modalPr_id).innerHTML+'</td>';
                printContents += '<td style="width:50%;" class="px-3 py-1 align-top"></td></tr>';
                printContents +=tablefooter;
            }else{
               for(let j in groups){
                 for(let i in groups[j]){
                   if(i == 0) {
                    let mt="margin-top: 0px";let heightF="height: auto";
                     if(j!=0) {mt="margin-top: 10px";heightF="height: 8mm";}
                      printContents += '<table style="margin-bottom: 100px;'+mt+'" class="min-w-full" style="page-break-after: avoid; page-break-before: avoid;"><tbody class="bg-white">';
                      printContents += '<tr class="w-full"><td style="'+heightF+';border:none!important"  class="px-1 py-1 align-top">';
                      if(j==0){
                          printContents += '<label class="text-black block text-xs whitespace-normal" style="font-size: 0.43rem;line-height: 0.80rem;"><span class="font-bold">Total orders:</span> <span style="font-size: 0.43rem;" class="text-black text-xs tracking-wide"> '+this.shippings.length+'</span>';
                          if(this.shippings[0].courier) printContents += '<span style="margin-left:5px"><span class="font-bold">Courier:</span><span style="font-size: 0.43rem;" class="text-black text-xs tracking-wide"> ' +this.shippings[0].courier.fullName+' </span>';
                          printContents += '</span><span style="margin-left:5px"><span class="font-bold">Zone:</span>';
                          if(this.shippings[0].zone) printContents += '<span style="font-size: 0.43rem;" class="text-black text-xs tracking-wide"> '+this.shippings[0].zone.name+' </span>';
                          printContents += '</label>';
                      } 
                      printContents += '</td><td style="border:none!important" class="px-3 py-1 align-top"><label class="text-black block text-xs whitespace-normal" style="font-size: 0.43rem;line-height: 0.80rem;"></td></tr>';
                    
                      printContents += '</tbody><tbody>';
                  } 
                  let modalPr_id = "ModalprintList_" + groups[j][i];
                  let height="height: 38mm";
                  if(i % 2 == 0){
                     printContents += '<tr style="'+height+'" class="bg-white">';
                  }
                  printContents += '<td style="width:50%;" class="px-1 py-1 align-top border border-black">'+document.getElementById(modalPr_id).innerHTML+'</td>';
                  if(i % 2 != 0){
                      printContents += '</tr>';
                  }
                  if(i == groups[j][i].length-1)  printContents +=tablefooter;
                 }
               }
          }
              // console.log(window.location.pathname.split( '/' ))
                  var mywindow = window.open('', 'PRINT', 'height=400,width=600');
                  mywindow.document.write('<html lang="en"><head><meta charset="utf-8"><title>DELIVRY NOTE</title>');
                  mywindow.document.write('<style type="text/css">.overflow-visible{white-space: initial;}.trakingn img{width: 50%;}.mb-0{margin-bottom: 0px;}.w-1/4{width: 25%;}.w-3/4{width: 75%;}.m-0{margin:0}.pt-0{padding-top: 0px;}.mt-0{margin-top: 0px;}.py-1{padding-top: 0.25rem;padding-bottom: 0.25rem;}.px-3{padding-left: 0.75rem;padding-right: 0.75rem;}.w-2/4{width: 50%;}.mt-1{margin-top: 0.25rem;}.align-top{vertical-align: top;}p{margin:0}table{border-collapse: collapse;}table th, table td {border:1px solid #000;}.text-right{text-align:right}.flex-1{flex:1 1 0%}.w-40{width:10rem}.font-medium{font-weight:500}.py-1{padding-top:.25rem;padding-bottom:.25rem}.inline-block{display:inline-block}.mb-3{margin-bottom:.75rem}.py-2{padding-top:.5rem;padding-bottom:.5rem}.ml-auto{margin-left:auto}.border-black{border: 1px solid black;}.border{border-width:1px}.whitespace-no-wrap{white-space:nowrap}.text-center{text-align:center}.w-1/4{width: 25%}.text-left{text-align:left}.px-2{padding-left:.5rem;padding-right:.5rem}.min-w-full{min-width:100%}.mb-5{margin-bottom:1.25rem}.px-1{padding-left:.25rem;padding-right:.25rem}.mx-auto{margin-left:auto;margin-right:auto}body{font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";font-size:1em}.justify-between{justify-content:space-between}.w-full{width:100%}.block{display:block}.flex{display:flex}.uppercase{text-transform: uppercase;}.mb-2{margin-bottom: 0.5rem;}.mb-3{margin-bottom: 0.75rem;}.font-bold{font-weight: 700;}.font-semibold{font-weight:600}.text-xl{font-size: 1.25rem;line-height: 1.75rem;}.size-m{font-size: 12px;font-weight: 500;}@media print {@page {size:  auto; margin: 0mm;}}</style>');
                  mywindow.document.write('</head><body style="margin:8mm">');
                  mywindow.document.write(printContents);
                  mywindow.document.write('</body></html>');
                  mywindow.document.close(); // necessary for IE >= 10
                  mywindow.focus(); // necessary for IE >= 10*/
                  setTimeout(function () {
                      mywindow.print();
                      mywindow.close();
                  }, 500);
                  return false;
        
    },
  },
};
</script>

<style>
</style>




